module.exports = __webpack_public_path__ + "img/users-regular.c8196b58.svg";